import angular from 'angular';
import moment from 'moment';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import guid from '@/shared/utils/guid';

angular.module('cloudX').directive('cxEnumPicker', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        type: '@',
        placeholder: '@',
        extraId: '@',
        extraLabel: '@',
        autofocus: '=',
      },
      bindToController: true,
      template: `<div>
        <tags-input
          ng-model="ctrl.selected"
          placeholder="{{ctrl.placeholder}}"
          display-property="label"
          key-property="id"
          on-tag-added="ctrl.updateValue()"
          on-tag-removed="ctrl.updateValue()"
          replace-spaces-with-dashes="false"
          add-from-autocomplete-only="true"
          min-length="1"
          class="bootstrap">
          <auto-complete
            source="ctrl.getSuggestions($query)"
            max-results-to-show="100"
            load-on-focus="true"
            load-on-empty="true"
            display-property="label"
            min-length="0"></auto-complete>
        </tags-input>
      </div>`,
      require: ['ngModel', 'cxEnumPicker'],
      link: function($scope, el, attrs, controllers) {
        if (!controllers || controllers.length !== 2) return;
        const [ngModel, ctrl] = controllers;
        if (ctrl.autofocus) {
          $timeout(function() {
            el.find('input')
              .first()
              .focus();
          });
        }

        ctrl.view2model = function(value) {
          ngModel.$setViewValue(value);
        };

        // when angular detects a change to the model,
        // we update our inner value
        ngModel.$render = function() {
          ctrl.setValue(ngModel.$viewValue);
        };
      },
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        '$rootScope',
        'enumCacheSvc',
        'translateListFilter',
        'dataCache',
        '$filter',
        function($scope, $rootScope, enumCacheSvc, translateListFilter, dataCache, $filter) {
          const ctrl = this;

          ctrl.$onInit = function() {
            ctrl.selected = [];
            ctrl.options = null;
            ctrl.tmpValue = null; //Init after loading
            enumCacheSvc.get(ctrl.type).then(function(data) {
              ctrl.options = data.map(item => ({
                ...item,
                id: item.key,
                label: translateListFilter(item.key, ctrl.type, item.value),
                sort: 1,
              }));
              if (ctrl.extraLabel && ctrl.extraId) {
                ctrl.options.push({
                  id: ctrl.extraId,
                  label: ctrl.extraLabel,
                  sort: 0,
                });
              }
              ctrl.options.sort(dynamicSortMultiple('sort', 'label'));
              if (!!ctrl.tmpValue) {
                ctrl.selected = ctrl.tmpValue.map(x => ctrl.findOption(x));
              }
            });
          };

          ctrl.findOption = function(code) {
            if (code == null || !ctrl.options || ctrl.options.length === 0) return null;
            return ctrl.options.find(el => el.id === code);
          };

          ctrl.getSuggestions = function(search) {
            return $filter('filter')(ctrl.options, search);
          };

          ctrl.updateValue = function() {
            ctrl.view2model(ctrl.selected.map(x => x.id));
          };
          ctrl.setValue = function(value) {
            ctrl.tmpValue = null;
            if (value !== null && typeof value !== 'undefined' && angular.isArray(value)) {
              if (ctrl.options !== null) {
                ctrl.selected = value.map(x => ctrl.findOption(x));
              } else {
                //Options not loaded yet
                ctrl.tmpValue = value;
              }
            } else {
              ctrl.selected = [];
            }
          };
          const translateLabels = function() {
            if (!ctrl.options) return;
            angular.forEach(ctrl.options, item => {
              if (item.id === guid.empty) {
                item.label = ctrl.emptyGuidLabel;
                return;
              }
              item.label = translateListFilter(item.key, ctrl.type, item.value);
            });
            ctrl.options.sort(dynamicSortMultiple('sort', 'label'));
          };
          const deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
          $scope.$on('$destroy', deregistration);
        },
      ],
    };
  },
]);
